import { useState } from 'react';
import { useGetItem } from 'Features/HTTP/RequestHandlers';
import { useResponseHandler, useErrorHandler } from 'Features/HTTP/ResponseHandler';
import { useTranslation } from 'react-i18next';
import apiConfig from 'Application/configurations/apiConfig';
import IReadAccount from './IReadAccount';
import { useAccessTokens } from 'Features/Authentication';

const useGetAccount = () => {

    const { t } = useTranslation();
    const getItem = useGetItem();
    const responseHandler = useResponseHandler();
    const errorHandler = useErrorHandler();
    const [ account, setAccount ] = useState<IReadAccount>({id: "", companyId: "", username: "", name: "", firstName: "", lastName: "", phoneNumber: "", email: "", isActive: true});
    const getToken = useAccessTokens();
    const AccessAsUser = apiConfig.scopes.AccessAsUser;

    /** Read account by guid
     * @param {string} id - guid of the account
     * @returns {object} account - account object
     **/
    const getAccountById = async (companyId: any, accountId: any) => {

        const basePath = apiConfig.basePath;
        const companyEndpoint = apiConfig.endpoints.companies
        const accountEndpoint = apiConfig.endpoints.accounts;
        const url = new URL(`${basePath}/${companyEndpoint}/${companyId}/${accountEndpoint}/${accountId}`);
        const accessToken = await getToken([AccessAsUser]);

        const options = {
            accessToken: accessToken
        }

        try {

            const response = await getItem(url, options);
            const data = response?.data || [];
            setAccount(data);
            return responseHandler(response, "useGetAccount", { operation: "read", hide: true });

        } catch (error: any) {

            let problemTitle = error && error.data && error.data.title ? error.data.title : "";
            let body = null;

            if (problemTitle === "General.RequestorNotExist") body = t('features.account.requestorNotExist');
            if (problemTitle === "UserAccount.NotExist") body = t('features.account.userAccountNotExist');
            if (problemTitle === "UserAccount.UserDataAccessDenied") body = t('features.account.userDataAccessDenied');
            if (problemTitle === "Company.NotExist") body = t('features.account.companyNotExist');
            if (problemTitle === "UserAccount.ReadPermissionDenied") body = t('features.account.readPermissionDenied');

            return errorHandler(error, "useGetAccount", { operation: "read", hide: false, messageBody: body });

        }

    }

    return { account, setAccount, getAccountById };

}

export default useGetAccount;
